// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"afec25e5","455":"15c7919d"}[chunkId] + ".chunk.js";
};